import { FC, useCallback, useState } from "react";
import { Box, HStack, useMediaQuery } from "@chakra-ui/react";

import { ScheduleItemDetails } from "./ScheduleItemDetails.tsx";
import { IScheduleItem } from "../../../../../api/schedule/types.ts";
import { ScheduleItemCircleStatus } from "./ScheduleItemCircleStatus.tsx";
import { ScheduleItemDateWithInfo } from "./ScheduleItemDateWithInfo.tsx";
import { ScheduleItemAmountWithArrow } from "./ScheduleItemAmountWithArrow.tsx";

interface Props {
  payment: IScheduleItem;
}

export const PaymentsScheduleItem: FC<Props> = ({ payment }) => {
  const [isSmallScreen] = useMediaQuery("(max-width: 355px)");
  const [showDetails, setShowDetails] = useState<boolean>(false);

  const onClick = useCallback(() => {
    setShowDetails(!showDetails);
  }, [showDetails]);

  return (
    <Box onClick={onClick} cursor="pointer">
      <HStack h={isSmallScreen ? "unset" : "36px"} justifyContent="space-between">
        <HStack spacing={0}>
          <ScheduleItemCircleStatus order={payment.idx} status={payment.status} />
          <ScheduleItemDateWithInfo payment={payment} />
        </HStack>

        <ScheduleItemAmountWithArrow payment={payment} showDetails={showDetails} />
      </HStack>

      <ScheduleItemDetails showDetails={showDetails} payment={payment} />
    </Box>
  );
};
